import { DownOutlined, PlusOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons';
import type { ColDef, GridApi } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { ConfigProvider, Input, Pagination, Select, TreeSelect } from 'antd';
import viVN from 'antd/locale/vi_VN';
import React, { useEffect, useRef, useState } from 'react';
import { getListCarCompany, getSLUnitOption, type ISelectOption } from '../../../../../../api/selectOptions/selectOptionsApi';
import { NodataTable } from '../../../../../../components/NoDataTable';
import { fommatSelectOption, fommatSelectOptionUnit, formatPrice } from '../../../../../../until';
import '../../../style.scss';
import { IDataFilterGroupList, IInforAddGroup, IPagination, ISelectedCustomer } from '../../AddGroup/AddNewGroup';
import { useCustomerGroupContext } from '../../../indexV2';
import { formatNumber } from '../../../../../../services/mixin';


interface Props {
    memoizedColumnDefs: ColDef<any, any>[];
    listCustomerNoAutomatic: any[];

    pagination: IPagination;
    dataFilterList: IDataFilterGroupList;
    // selectedIdCustomer: Set<number>

    inforAddGroup: IInforAddGroup
    selectedIdCustomerV9: ISelectedCustomer[]

    setDataFilterList: (dataFilterList: IDataFilterGroupList) => void;
    // setSelectedIdCustomer: (data: Set<number>) => void;
    onPaginationChange: (page: number, pageSize: number) => void;
}

const CG_PrivateNoAutomatic: React.FC<Props> = ({
    memoizedColumnDefs, listCustomerNoAutomatic,

    pagination, dataFilterList,
    inforAddGroup, selectedIdCustomerV9,

    setDataFilterList, onPaginationChange,
}) => {
    const {
        // sLCategoryCar, sLUnit,
        sLCategoryCar, sLNationwide,
        handleOpenDataFields
    } = useCustomerGroupContext();

    return (
        <div className="custom-page-css w-full flex flex-col gap-2 bg-white p-4 rounded">
            {/* Header */}
            <div className="custom-page-css flex gap-2 items-center">
                <span className="custom-page-css text-base font-regular">Danh sách khách hàng</span>
                <div className="custom-page-css flex items-center justify-center p-1 rounded-full bg-E6F7FF cursor-pointer">
                    <PlusOutlined style={{ color: '#1890FF' }} />
                </div>
            </div>

            {/* Filters */}
            <div className="custom-page-css flex items-center gap-2">
                <div className="custom-page-css flex-1 d-flex align-center gap-2">
                    <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3 py-2-px justify-between overflow-hidden">
                        <div className="d-flex align-center w-full">
                            {/* <Select
                                showSearch={false}
                                allowClear
                                mode="multiple"
                                className="w-full text-left text-span-select text-sm bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector border-none"
                                popupClassName="position-dropdow custome-select-item h-popUp"
                                variant="borderless"
                                placeholder="Đơn vị"
                                suffixIcon={null}
                                options={sLUnit}
                                value={dataFilterList?.listUnit}
                                onChange={(e) => setDataFilterList({ ...dataFilterList, listUnit: e })}
                            /> */}

                             <TreeSelect
                                className={'custome-select-t w-full border-F2F4F7'}
                                multiple
                                showSearch
                                placeholder="Chọn đơn vị"
                                allowClear
                                value={dataFilterList?.listUnit}
                                treeDefaultExpandAll={false}
                                treeData={sLNationwide}
                                filterTreeNode={(input: string, option: any) =>
                                    typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={(e) => setDataFilterList({ ...dataFilterList, listUnit: e })}
                            />
                        </div>
                        {/* <div className="h-full d-flex align-center">
                            <DownOutlined className="text-sm text-98A2B3" />
                        </div> */}
                    </div>
                </div>

                <div className="custom-page-css flex-1 d-flex align-center gap-2">
                    <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3 py-2-px justify-between overflow-hidden">
                        <div className="d-flex align-center w-full">
                            <Select
                                showSearch={false}
                                allowClear
                                mode="multiple"
                                className="w-full text-left text-span-select text-sm bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector border-none"
                                popupClassName="position-dropdow custome-select-item h-popUp"
                                variant="borderless"
                                placeholder="Thương hiệu"
                                suffixIcon={null}
                                options={sLCategoryCar}
                                value={dataFilterList?.listCategoryCar}
                                onChange={(e) => setDataFilterList({ ...dataFilterList, listCategoryCar: e })}
                            />
                        </div>
                        <div className="h-full d-flex align-center">
                            <DownOutlined className="text-sm text-98A2B3" />
                        </div>
                    </div>
                </div>

                <div className="custom-page-css flex-2 border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3 justify-between overflow-hidden">
                    <Input
                        placeholder="Tìm kiếm thông tin khách hàng"
                        className="bg-FCFCFD text-sm border-none custom-input-focus none-focus-erro font-regular p-none-input place-holder-input-667085 hover-none"
                        value={dataFilterList.search}
                        onChange={(e) => setDataFilterList({ ...dataFilterList, search: e.target.value })}
                    />
                    <div className="border-l-F2F4F7 h-full d-flex align-center">
                        <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
                    </div>
                </div>
            </div>

            {/* Counter */}
            <div className="custom-page-css flex items-center justify-betweeen gap-1">
                <div className="custom-page-css flex items-center gap-1">
                    <span className="custom-page-css text-base text-4B4B4B font-regular">Đã chọn:</span>
                    <span className="custom-page-css text-base text-344054 font-regular">{formatPrice(selectedIdCustomerV9.length)} khách hàng</span>
                </div>
                <div className="custom-page-css flex items-center justify-end gap-2">
                    <div className="btn-input t-px-8 cursor-pointer"
                        onClick={handleOpenDataFields}
                    >
                        <div className="icon-svg">
                            <SettingOutlined />
                        </div>
                    </div>
                </div>
            </div>
            {/* Grid */}
            <div className="ag-theme-alpine custom-table-ag">
                <AgGridReact
                    domLayout="autoHeight"
                    className="my-auto-height-grid"
                    getRowStyle={(params: any) => ({
                        backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                    })}
                    columnDefs={memoizedColumnDefs}
                    rowData={listCustomerNoAutomatic}
                    rowHeight={55}
                    defaultColDef={{
                        resizable: true
                    }}
                    overlayNoRowsTemplate={NodataTable}
                // rowSelection={{ mode: 'multiRow' }} selectionColumnDef={{ pinned: 'left', lockPosition: 'left', suppressMovable: true }}
                // getRowId={getRowId}
                // onGridReady={onGridReady}
                // onSelectionChanged={onSelectionChanged}
                />
            </div>

            {/* Pagination */}
            <ConfigProvider locale={viVN}>
                <div className="pagination-block">
                    <Pagination
                        showSizeChanger
                        current={pagination.current}
                        pageSize={pagination.pageSize}
                        total={pagination.total}
                        itemRender={(page, type, originalElement) => {
                            // Chỉ custom khi là nút số trang
                            if (type === 'page') {
                                return <span>{formatNumber(page)}</span>;
                            }
                            // prev / next / jump-prev / jump-next giữ nguyên
                            return originalElement;
                        }}
                        className="rs-pagination"
                        onChange={onPaginationChange}
                    />
                </div>
            </ConfigProvider>
        </div>
    );
};

export default React.memo(CG_PrivateNoAutomatic)